import _asyncToGenerator from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { breadcrumb } from '@/settings';
import Hamburger from '@/components/Hamburger';
import MessageEntrance from '@/components/MessageAgentSub/MessageEntrance';
import { setToken } from '@/utils/auth';
export default {
  components: {
    Hamburger: Hamburger,
    MessageEntrance: MessageEntrance
  },
  data: function data() {
    console.log(process.env);
    return {
      imgs: {
        img1: require('../../assets/frame/frame 1.png'),
        img2: require('../../assets/frame/frame 2.png'),
        img3: require('../../assets/frame/frame 3.png'),
        img4: require('../../assets/frame/frame 4.png'),
        img5: require('../../assets/frame/frame 5.png'),
        img6: require('../../assets/frame/frame 6.png'),
        img7: require('../../assets/frame/frame 7.png'),
        img8: require('../../assets/frame/frame 8.png'),
        img9: require('../../assets/frame/frame 9.png'),
        img0: require('../../assets/frame/frame 0.png')
      },
      images: '',
      robotModalVisible: false,
      theme: process.env.VUE_APP_theme,
      isShowCopyRight: process.env.VUE_APP_show_copyright
    };
  },
  created: function created() {
    var _this = this;
    this.$API.getRequest({
      url: '/platform/todo/photo'
    }).then(function (res) {
      _this.images = res.result.imageBase64;
    });
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['sidebar', 'avatar'])), {}, {
    user: function user() {
      return this.$store.state.settings.userinfo;
    }
  }),
  mounted: function mounted() {},
  methods: {
    resource: function resource() {
      this.$store.dispatch('settings/clearNavStatus', '我的收藏');
      this.$router.push({
        path: '/system/collect'
      });
    },
    toHome: function toHome() {
      this.$store.dispatch('settings/clearNavStatus', '首页');
      this.$router.push('/');
    },
    toZl: function toZl() {
      window.open('http://km.hexasino.com/pc/login/loginpage');
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    logout: function logout() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.$store.dispatch('settings/changeSetting', {
                  key: 'menuactivehome',
                  value: false
                });
                _context.next = 3;
                return _this2.$store.dispatch('user/logout');
              case 3:
                _context.next = 5;
                return _this2.$store.dispatch('settings/changeSetting', {
                  key: 'breadcrumb',
                  value: breadcrumb
                });
              case 5:
                _this2.$store.dispatch('settings/clearNavStatus');
                sessionStorage.removeItem('dist_info');
                sessionStorage.removeItem('resourcePath');
                _this2.$router.push("/home?redirect=".concat(_this2.$route.fullPath));
              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    home: function home() {
      sessionStorage.setItem('resourcePath', JSON.stringify({
        resourcePath: '首页'
      }));
      this.$store.dispatch('settings/changeSetting', {
        key: 'breadcrumb',
        value: {
          resourcePath: '首页'
        }
      });
      this.$store.dispatch('settings/clearNavStatus', '首页');
      this.$store.dispatch('settings/changeSetting', {
        key: 'menuactivehome',
        value: true
      });
      this.$router.push('/');
    },
    gotoHelpDoc: function gotoHelpDoc() {
      this.$store.dispatch('settings/clearNavStatus', '帮助文档');
      this.$router.push({
        path: '/system/helpDoc/nomalHelpDoc'
      });
    },
    deleteToken: function deleteToken() {
      setToken('21443');
    }
  }
};